import { useState } from "react";

const FAQS = [
  {
    q: "恋爱辅助器漫画是什么类型的作品？",
    a: "它是一部以「恋爱系统」为设定的浪漫治愈系漫画。整体风格轻松温暖，融合了校园日常、系统数值与个人成长元素，既有趣味性也有情感深度。",
  },
  {
    q: "恋爱辅助器系统到底是如何运作的？",
    a: "辅助器会实时显示心动值、好感度，并通过限时任务、道具商城与限时事件来引导主角与人相处。不过它只提供提示和引导，无法直接改变他人想法，真正的选择权始终在主角手中。",
  },
  {
    q: "这部漫画适合什么样的读者？",
    a: "适合喜欢校园恋爱、治愈成长类故事的读者。如果你对「系统流」「数值恋爱」这类设定感兴趣，或者想看到主角如何从社恐一点点变得勇敢，都会很容易代入其中。",
  },
  {
    q: "故事的核心主题是什么？",
    a: "作品反复强调「真实比技巧更重要」。它用辅助器的数值设定制造笑料与冲突，最终落点却是真诚、勇气与自我和解，是一部「看似在恋爱、实则谈成长」的漫画。",
  },
  {
    q: "在哪里可以追更这部漫画？",
    a: "可前往你常用的漫画阅读平台，搜索「恋爱辅助器」即可找到正版更新入口。本站仅做设定与剧情解析，不提供任何盗版资源，请支持正版创作者。",
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-sm font-medium text-accent-700">
            <i className="ri-question-answer-line"></i>
            读者问答
          </span>
          <h2 className="mt-5 font-heading text-3xl leading-snug text-foreground-900 md:text-4xl">
            常见<span className="text-primary-600">问题</span>
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            关于这部漫画，你可能还有这些疑问。我们整理了读者最常问的问题，一次为你解答。
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {FAQS.map((f, i) => {
            const open = openIndex === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-2xl border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5"
                >
                  <span className="flex items-center gap-3 text-base font-medium text-foreground-900 md:text-lg">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs font-bold text-primary-700">
                      Q
                    </span>
                    {f.q}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-xl text-foreground-500 transition-transform duration-300 ${
                      open ? "rotate-180" : ""
                    }`}
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600 md:px-6 md:py-5">
                      <span className="mr-2 inline-flex h-7 w-7 items-center justify-center rounded-full bg-secondary-100 text-xs font-bold text-secondary-700">
                        A
                      </span>
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}